import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

// GET /api/admin/crawl/sources?customerUuid={uuid}
export const getSources = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/sources?customerUuid=${uuid}`, { headers });
};

// GET /api/admin/crawl/sources/{id}
export const getSource = async (id) => {
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/sources/${id}`, { headers });
};

// POST /api/admin/crawl/sources?customerUuid={uuid}
export const createSource = async (data) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/sources?customerUuid=${uuid}`, {
    headers,
    body: data,
  });
};

// PUT /api/admin/crawl/sources/{id}
export const updateSource = async (id, data) => {
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/admin/crawl/sources/${id}`, {
    headers,
    body: data,
  });
};

// DELETE /api/admin/crawl/sources/{id}
export const deleteSource = async (id) => {
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/admin/crawl/sources/${id}`, { headers });
};

// POST /api/admin/crawl/start/{sourceId}
export const triggerCrawl = async (sourceId) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/start/${sourceId}`, { headers });
};

// GET /api/admin/crawl/sources/{sourceId}/jobs?page={page}&size={pageSize}
export const getJobs = async (sourceId, page = 1, pageSize = 20) => {
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/sources/${sourceId}/jobs?page=${page - 1}&size=${pageSize}`, { headers });
};

// GET /api/admin/crawl/jobs/{jobId}
export const getJob = async (jobId) => {
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/jobs/${jobId}`, { headers });
};

// GET /api/admin/crawl/jobs/{jobId}/urls?search=&filter=&page=&pageSize=
export const getJobUrls = async (jobId, params = {}) => {
  const headers = await getHeaders();
  const qs = new URLSearchParams();
  if (params.search) qs.set("search", params.search);
  if (params.filter) qs.set("filter", params.filter);
  if (params.page != null) qs.set("page", params.page);
  if (params.pageSize != null) qs.set("pageSize", params.pageSize);
  const query = qs.toString();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/jobs/${jobId}/urls${query ? "?" + query : ""}`, { headers });
};

// POST /api/admin/crawl/jobs/{jobId}/stop
export const stopJob = async (jobId) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/jobs/${jobId}/stop`, { headers });
};

// POST /api/admin/crawl/jobs/{jobId}/retries
export const retryJob = async (jobId, body = {}) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/jobs/${jobId}/retries`, { headers, body });
};

// ── Taxonomy Management ──

// POST /api/admin/crawl/taxonomy/generate
export const triggerTaxonomyGeneration = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/generate?customerUuid=${uuid}`, { headers });
};

// GET /api/admin/crawl/taxonomy/jobs
export const getTaxonomyJobs = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/jobs?customerUuid=${uuid}`, { headers });
};

// GET /api/admin/crawl/taxonomy/jobs/{jobId}
export const getTaxonomyJob = async (jobId) => {
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/jobs/${jobId}`, { headers });
};

// POST /api/admin/crawl/taxonomy/jobs/{jobId}/approve
export const approveTaxonomyJob = async (jobId, body = {}) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/jobs/${jobId}/approve`, { headers, body });
};

// GET /api/admin/crawl/taxonomy/topics
export const getTaxonomyTopics = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/topics?customerUuid=${uuid}`, { headers });
};

// GET /api/admin/crawl/taxonomy/settings
export const getTaxonomySettings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/settings?customerUuid=${uuid}`, { headers });
};

// PUT /api/admin/crawl/taxonomy/settings
export const updateTaxonomySettings = async (data) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/admin/crawl/taxonomy/settings?customerUuid=${uuid}`, { headers, body: data });
};
